import React, { useEffect, useState } from 'react'
import { useHistory, useLocation } from 'react-router-dom';
import { Box, colors } from '@mui/material';
import axios from 'axios';
import { useStore } from '../store/StoredData';

const Tabs = () => {
    const history = useHistory()
    const location = useLocation()
    const { currentUser } = useStore()
    const [showEditorBio, setShowEditorBio] = useState(false)

    const activeStyle = { background: colors.indigo[800], color: '#fff', cursor: 'pointer' }
    const idleStyle = { background: '#FFF', cursor: 'pointer' }

    useEffect(() => {
        let cancelled = false
        const cmsUserId = currentUser?.userid
        if (!cmsUserId) {
            setShowEditorBio(false)
            return undefined
        }
        axios
            .get('/api/editor-bio/access', { params: { cms_user_id: cmsUserId } })
            .then(() => {
                if (!cancelled) setShowEditorBio(true)
            })
            .catch(() => {
                if (!cancelled) setShowEditorBio(false)
            })
        return () => {
            cancelled = true
        }
    }, [currentUser?.userid])

    return (
        <>
            <Box py={1} px={0.75} bgcolor={colors.indigo[50]}>
                <Box
                    display='flex'
                    flexWrap='nowrap'
                    justifyContent='space-evenly'
                    alignItems='center'
                    textAlign='center'
                    sx={{ gap: '6px', overflowX: 'hidden' }}
                >
                    <Box
                        border={1}
                        borderColor={colors.indigo[800]}
                        borderRadius={1}
                        py={0.25}
                        px={0.75}
                        color={colors.indigo[800]}
                        fontSize={13}
                        fontWeight={500}
                        whiteSpace='nowrap'
                        style={location.pathname === '/home' ? activeStyle : idleStyle}
                        onClick={() => history.push('/home')}
                    >Search Article</Box>
                    <Box
                        border={1}
                        borderColor={colors.indigo[800]}
                        color={colors.indigo[800]}
                        borderRadius={1}
                        py={0.25}
                        px={0.75}
                        fontSize={13}
                        fontWeight={500}
                        whiteSpace='nowrap'
                        style={location.pathname === '/realtime-people' ? activeStyle : idleStyle}
                        onClick={() => history.push('/realtime-people')}
                    >Realtime People</Box>
                    <Box
                        border={1}
                        borderColor={colors.indigo[800]}
                        color={colors.indigo[800]}
                        borderRadius={1}
                        py={0.25}
                        px={0.75}
                        fontSize={13}
                        fontWeight={500}
                        whiteSpace='nowrap'
                        style={location.pathname === '/news-summary' ? activeStyle : idleStyle}
                        onClick={() => history.push('/news-summary')}
                    >News Summary</Box>
                    <Box
                        border={1}
                        borderColor={colors.indigo[800]}
                        color={colors.indigo[800]}
                        borderRadius={1}
                        py={0.25}
                        px={0.75}
                        fontSize={13}
                        fontWeight={500}
                        whiteSpace='nowrap'
                        style={location.pathname.startsWith('/ownership-news') ? activeStyle : idleStyle}
                        onClick={() => history.push('/ownership-news')}
                    >Ownership News</Box>
                    <Box
                        border={1}
                        borderColor={colors.indigo[800]}
                        color={colors.indigo[800]}
                        borderRadius={1}
                        py={0.25}
                        px={0.75}
                        fontSize={13}
                        fontWeight={500}
                        whiteSpace='nowrap'
                        style={location.pathname.startsWith('/earnings-news') ? activeStyle : idleStyle}
                        onClick={() => history.push('/earnings-news')}
                    >Earnings News</Box>
                    {/* Sector Screen: earlier implementation as a tab. Moved to the "Sector Wise Drafts" button in Header.jsx as in the mockup
                    <Box
                        border={1}
                        borderColor={colors.indigo[800]}
                        color={colors.indigo[800]}
                        borderRadius={1}
                        py={0.25}
                        px={0.75}
                        fontSize={13}
                        fontWeight={500}
                        whiteSpace='nowrap'
                        style={location.pathname.startsWith('/sector-screen') ? activeStyle : idleStyle}
                        onClick={() => history.push('/sector-screen')}
                    >Sector Screen</Box> */}
                    <Box
                        border={1}
                        borderColor={colors.indigo[800]}
                        color={colors.indigo[800]}
                        borderRadius={1}
                        py={0.25}
                        px={0.75}
                        fontSize={13}
                        fontWeight={500}
                        whiteSpace='nowrap'
                        style={location.pathname.startsWith('/dashboard') ? activeStyle : idleStyle}
                        onClick={() => history.push('/dashboard')}
                    >Dashboard</Box>
                    <Box
                        border={1}
                        borderColor={colors.indigo[800]}
                        color={colors.indigo[800]}
                        borderRadius={1}
                        py={0.25}
                        px={0.75}
                        fontSize={13}
                        fontWeight={500}
                        whiteSpace='nowrap'
                        style={location.pathname.startsWith('/card-variance-report') ? activeStyle : idleStyle}
                        onClick={() => history.push('/card-variance-report')}
                    >CARD Variance</Box>
                    <Box
                        border={1}
                        borderColor={colors.indigo[800]}
                        color={colors.indigo[800]}
                        borderRadius={1}
                        py={0.25}
                        px={0.75}
                        fontSize={13}
                        fontWeight={500}
                        whiteSpace='nowrap'
                        style={location.pathname.startsWith('/guardrails-for-stage') ? activeStyle : idleStyle}
                        onClick={() => history.push('/guardrails-for-stage')}
                    >GuardRails for Stage</Box>
                    <Box
                        border={1}
                        borderColor={colors.indigo[800]}
                        color={colors.indigo[800]}
                        borderRadius={1}
                        py={0.25}
                        px={0.75}
                        fontSize={13}
                        fontWeight={500}
                        whiteSpace='nowrap'
                        style={location.pathname.startsWith('/manage-stage-datasets') ? activeStyle : idleStyle}
                        onClick={() => history.push('/manage-stage-datasets')}
                    >Manage STAGE Datasets</Box>
                    <Box
                        border={1}
                        borderColor={colors.indigo[800]}
                        color={colors.indigo[800]}
                        borderRadius={1}
                        py={0.25}
                        px={0.75}
                        fontSize={13}
                        fontWeight={500}
                        whiteSpace='nowrap'
                        style={location.pathname.startsWith('/chatbot-prompt') ? activeStyle : idleStyle}
                        onClick={() => history.push('/chatbot-prompt')}
                    >Chatbot Prompt</Box>
                    {showEditorBio ? (
                    <Box
                        border={1}
                        borderColor={colors.indigo[800]}
                        color={colors.indigo[800]}
                        borderRadius={1}
                        py={0.25}
                        px={0.75}
                        fontSize={13}
                        fontWeight={500}
                        whiteSpace='nowrap'
                        style={location.pathname.startsWith('/editor-bio') ? activeStyle : idleStyle}
                        onClick={() => history.push('/editor-bio')}
                    >Editor Bio</Box>
                    ) : null}
                </Box>
            </Box>
        </>
    )
}

export default Tabs
